import React from "react";

const SettingsLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
        <g
            transform="translate(1.215 .5)"
            stroke={color}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M20.613 13.565H24v-3.13h-3.388c-.218-.905-.575-2.276-1.047-3.05l2.396-2.394-2.952-2.952-2.397 2.396c-.772-.472-2.142-.828-3.047-1.046V0h-3.13v3.39c-.905.217-2.276.573-3.048 1.045L4.99 2.039 2.038 4.991l2.397 2.396c-.472.772-.829 2.143-1.048 3.048H0v3.13h3.387c.22.905.576 2.276 1.048 3.048L2.038 19.01l2.952 2.951 2.396-2.397c.773.474 2.144.83 3.049 1.049V24h3.13v-3.387c.905-.22 2.276-.576 3.047-1.048l2.398 2.396 2.951-2.95-2.396-2.398c.472-.772.829-2.143 1.048-3.048z" />
            <circle cx="12" cy="12" r="4.696" />
        </g>
    </svg>
);

export default SettingsLine;
